<template>
  <div v-html="model.value"></div>
</template>

<script>
export default {
  props: {
    model: Object,
    value: [String, Number],
  },
};
</script>
